import React, { Component } from 'react';
import { Link as LinkFeather } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { AddButton } from '../../components/AddButton';
import { Loader } from '../../components/Loader';
import * as actions from "../../redux/chores";

class Chores extends Component {
    componentDidMount() {
        this.props.fetchchores(this.props);
    }

    renderTable() {
        return !this.props.chores ? null : <div>
            <AddButton to={`/chores/new`} />
            <table className='table table-striped'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.chores.map(chore =>
                        <tr key={chore.id}>
                            <td>{chore.name}</td>
                            <td><Link to={`/chores/${chore.id}`}><LinkFeather>Edit</LinkFeather></Link></td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    render() {
        return (
            <div>
                <h1>Chores</h1>
                <Loader loading={this.props.loading}>
                    {this.renderTable()}
                </Loader>
            </div>
        );
    }
}

const mapStateToProps = ({ chores }) => ({
    chores: chores.chores,
    loading: chores.loading,
    error: chores.error
});

export default connect(mapStateToProps, actions)(withRouter(Chores));


// WEBPACK FOOTER //
// ./src/pages/Chores/Chores.js